// removed by extract-text-webpack-plugin
module.exports = {"pending":"_1kZVNtz76mdBtOAive6mNc","in_progress":"_2JIUPUVX9XUQ6HmezwMajD","on_hold":"_3PqYm3tGHaZltaO2niGax1","cancelled":"_1QOjNKQgVep0fG5hA4oq62","completed":"pR1EPAiX9y0I1OFHVz64c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/lotStatusText/styles.css
// module id = 1101
// module chunks = 0